module.exports = __webpack_public_path__ + "img/logoTitle.0ca6ef17.png";